export default "__VITE_ASSET__BCV$t4wM__"